import { GlobalConfigType, setApplicationStep } from 'actions'
import cloneDeep from 'clone-deep'
import { FieldOrigin, InputType, LoanFieldProps } from 'config'
import { isCustomFieldKey } from 'config/loan.input.fields.constants'
import { visibleLoansLogic } from 'pages/LoanStructure/Logic'
import { store } from 'reducers'
import { InputValidate } from 'utils'
import { removeInvisibleFields } from 'utils/loan'

import { additionalPropertyInfoValidate } from '../AdditionalPropertyInformation/logics'
import { defaultInputs, ownerOccupiedOnlyFields, rentalIncomeFieldKeys } from './constants'

export const visiblePropertyFieldsLogic = () => {
  const { globalConfigReducer, loan } = store.getState()

  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  const fieldProps = loanFieldProperties[FieldOrigin.PropertyInformation]
  const visibleFields = Object.keys(fieldProps)

  const filtered = removeInvisibleFields(loan, FieldOrigin.PropertyInformation, visibleFields)
  if (loan?.proposedOccupancy === 'Owner Occupied') return filtered

  return filtered.filter((key) => !(ownerOccupiedOnlyFields as readonly string[]).includes(key))
}

export const initFields = (fields: Record<string, InputType>) => {
  const { loanDetail, globalConfigReducer } = store.getState()
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  const fieldProps = loanFieldProperties[FieldOrigin.PropertyInformation]

  const visibleFields = visibleLoansLogic()

  fieldProps &&
    Object.keys(fieldProps).map((key) => {
      if (!isCustomFieldKey(key) || visibleFields.includes(key)) return
      visibleFields.push(key)
    })

  if (Number(loanDetail.rateData?.price) > 0) {
    Object.keys(fields).map((key) => {
      if (visibleFields.indexOf(key) !== -1) {
        fields[key].disabled = true
        fields[key].tooltip = 'After selecting a price, you can only change it on the loan structure page.'
      }
    })
  }
  if (visibleFields.indexOf('secondLienPayment') === -1) fields['secondLienPayment'].visible = false

  Object.keys(fields).map((key) => {
    if (fieldProps[key]?.required !== undefined) fields[key].required = fieldProps[key].required
  })

  return fields
}

export const propertyInfoValidate = (validateOnly = false, updateStore = false): any => {
  const { loan, step, globalConfigReducer } = store.getState()
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  if (((loanFieldProperties as any)['visibility'] || {})[FieldOrigin.PropertyInformation] === false) {
    if (validateOnly) return true
    else return {}
  }
  let fields = initFields(defaultInputs())
  const fieldProps = loanFieldProperties[FieldOrigin.PropertyInformation]
  const visibleFields = visiblePropertyFieldsLogic()

  let success = true
  Object.keys(fields).map((key) => {
    if (!visibleFields.includes(key)) return
    if ((rentalIncomeFieldKeys as readonly string[]).includes(key) && !visibleFields.includes('rentalIncome')) return

    const error = InputValidate({ ...fields[key], value: loan[key] })

    if (error.length > 0) {
      success = false
      fields[key].error = error
    }
    if (fieldProps && fieldProps[key] && fieldProps[key].tooltip) fields[key].tooltip = fieldProps[key].tooltip
  })
  success = success && additionalPropertyInfoValidate()
  if (updateStore) {
    let application = cloneDeep(step.application)
    application.property = success ? 1 : -1
    store.dispatch(setApplicationStep(application))
  }
  if (validateOnly) return success
  return fields
}
